<template>
  <div
    class="product-gallery"
    :class="{ 'product-gallery--loading': loading }"
    v-if="!loading && typeof currentProduct !== 'undefined' && typeof this.productRealizations !== 'undefined'">

    <!-- Mobile: let's do a swiper -->
    <ProductGallerySwiper :realizations="this.productRealizations" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductGallerySwiper from '@/components/ProductGallery/ProductGallerySwiper/ProductGallerySwiper.vue'

export default {
  name: 'ProductGallery',
  components: {
    ProductGallerySwiper
  },
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/product-gallery.png')
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product',
      'realizations'
    ]),
    currentProduct: {
      get () {
        if (this.loading) return undefined
        return this.product(this.slug)
      }
    },
    productRealizations: {
      get () {
        if (this.loading) return undefined
        const filteredRealizations = this.realizations.filter(realization => {
          return realization.fields.products.findIndex(product => product.sys.id === this.currentProduct.sys.id) !== -1
        })
        if (filteredRealizations.length === 0) return undefined
        return filteredRealizations
      }
    }
    /*
    ,
    productRealizationsImages: {
      get () {
        if (this.loading) return undefined
        if (this.productRealizations.length === 0) return undefined
        return this.productRealizations.reduce((accumulator, realization) => {
          accumulator.push(realization.fields.image)
          return accumulator
        }, [])
      }
    }
    */
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts',
      'loadRealizations'
    ]),
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadProducts(), this.loadRealizations()])
        // await this.loadImage()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
